const carouselItems = [
  {
    title: '都市情感剧场',
    subtitle: '热播好剧一网打尽',
    desc: '《星辰大海》《都市夜话》《爱情公寓》等热门都市剧全集在线观看，免费高清不缓冲。',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20cityscape%20at%20twilight%20with%20soft%20golden%20light%2C%20modern%20urban%20skyline%2C%20film%20photography%20style%2C%20romantic%20atmosphere%2C%20professional%20cinematography%2C%20rich%20amber%20tones%2C%20no%20text%20no%20people&width=800&height=520&seq=carousel-01&orientation=landscape',
  },
  {
    title: '古装史诗巨制',
    subtitle: '权谋大剧震撼人心',
    desc: '《长安夜未央》《锦绣未央》《琅琊榜》等经典古装剧，服化道精良，演技在线。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20at%20golden%20sunset%2C%20traditional%20architecture%20with%20warm%20glowing%20lanterns%2C%20historical%20drama%20aesthetic%2C%20epic%20scale%2C%20cinematic%20lighting%2C%20professional%20film%20photography%2C%20no%20text%20no%20people&width=800&height=520&seq=carousel-02&orientation=landscape',
  },
  {
    title: '悬疑烧脑专区',
    subtitle: '高智商推理盛宴',
    desc: '《迷雾追踪》《白夜追凶》《隐秘的角落》等高分悬疑剧，每一个细节都不容错过。',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20rainy%20urban%20street%20at%20night%20with%20warm%20street%20lamp%20reflections%2C%20film%20noir%20atmosphere%2C%20suspense%20thriller%20cinematography%2C%20dark%20moody%20tones%20with%20amber%20highlights%2C%20professional%20photography%2C%20no%20text%20no%20people&width=800&height=520&seq=carousel-03&orientation=landscape',
  },
  {
    title: '好莱坞动作大片',
    subtitle: '肾上腺素飙升',
    desc: '《极速追击》《谍影重重》《速度与激情》等动作巨制高清上线，4K画质极致享受。',
    cover: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20scene%20with%20dramatic%20golden%20explosion%20lighting%2C%20urban%20night%20setting%2C%20Hollywood%20blockbuster%20aesthetic%2C%20intense%20dynamic%20composition%2C%20professional%20film%20photography%2C%20warm%20fire%20glow%2C%20no%20text%20no%20people&width=800&height=520&seq=carousel-04&orientation=landscape',
  },
  {
    title: '国漫精品合集',
    subtitle: '国产动画的黄金时代',
    desc: '《星辰变》《完美世界》《斗罗大陆》等热门国漫持续更新，制作精良画风绝美。',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20landscape%20with%20floating%20mountains%20and%20golden%20sunset%20sky%2C%20animation%20style%20scenery%2C%20epic%20fantasy%20world%2C%20warm%20magical%20atmosphere%2C%20digital%20art%20masterpiece%2C%20professional%20illustration%2C%20no%20text%20no%20characters&width=800&height=520&seq=carousel-05&orientation=landscape',
  },
  {
    title: '综艺爆笑合集',
    subtitle: '欢乐不停笑到停不下来',
    desc: '《欢乐集结号》《脱口秀大会》《王牌对王牌》等热门综艺全集，解压放松首选。',
    cover: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20stage%20with%20warm%20spotlight%20effects%2C%20variety%20show%20studio%20set%20design%2C%20entertainment%20atmosphere%2C%20bright%20golden%20and%20amber%20stage%20lights%2C%20professional%20broadcast%20environment%2C%20festive%20mood%2C%20no%20text%20no%20people&width=800&height=520&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-4">
            专题推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门专题合集
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            向日葵视频为你整理六大热门影视专题，快速定位你最爱的内容类型
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-lg font-bold text-background-50 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-sm text-background-50/80 mt-1">
                    {item.subtitle}
                  </p>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
                <a
                  href="#carousel"
                  onClick={(e) => e.preventDefault()}
                  className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors cursor-pointer"
                >
                  浏览专题 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}